import { useAuthUsername } from '@akin-home/auth/react';
import { StateUpdate } from '@akin-home/state-variables-frontend';
import { useUpdateStateVariables } from '@akin-home/state-variables-react';
import { useCallback } from 'react';
import { useCurrentUserID } from '../../users';
import { useApplicationID } from '../useAkinChat';

export const useUpdateChatState = () => {
  const id = useCurrentUserID();
  const username = useAuthUsername();
  const application_id = useApplicationID();
  const update = useUpdateStateVariables();

  return useCallback(
    (updates: StateUpdate[]) => {
      return update.mutateAsync({
        username: `${username}#${id}`,
        application_id,
        updates,
      });
    },
    [username, id, application_id]
  );
};
